<header class="main-header">
  <nav class="navbar" aria-label="Navegación principal">
    <a routerLink="/" class="brand" aria-label="Inicio SoluPrime">
      <img src="assets/logo-solusoft.jpg" alt="Soluprime" />
      <span>Soluprime</span>
    </a>

    <div class="nav-container">
      <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Inicio</a>
      <a routerLink="/quienes-somos" routerLinkActive="active">Quiénes Somos</a>
      <a routerLink="/contacto" routerLinkActive="active">Contacto</a>
     
    </div>
  </nav>
</header>

<main class="main-content">
  <router-outlet></router-outlet>
</main>

<footer class="footer">
  <div>
    <strong>Soluprime</strong>
    <span>Desarrollo de Software y Consultorías Informáticas</span>
  </div>
  <p>© 2026 Soluprime. Todos los derechos reservados.</p>
</footer>
